<template>
  <div class="py-4 border border-solid border-gray-200 rounded-lg px-4">
    <div class="flex items-center justify-between">
      <div class="flex items-center space-x-3">
        <img v-if="title === 'Google Classroom'" class="w-8 h-8 rounded-full" :src="icon" />
        <img v-else class="w-8 h-8 rounded-full" :src="`/static/integrations/${title}.png`" />
        <span class="text-base font-poppins font-semibold text-gray-800">
          {{ title }}
        </span>
      </div>
      <div>
        <pl-spinner v-if="loading" />
        <template v-else>
          <div v-if="type === 'connect'" class="flex items-center space-x-3 font-manrope">
            <Tooltip
              text="Go to your profile (bottom left) > click integrations to disconnect and reconnect Google Classroom option. This should it!"
              styleTooltip="top-0 right-full mr-2.5 -mt-1 shadow-md text-gray-800"
              backgroundColor="bg-white"
              textColor="text-gray-800"
            >
              <button v-if="title === 'Google Classroom'" class="rounded-full mt-1 mr-1.5 flex items-center space-x-2">
                <i class="fa-solid fa-circle-question"></i>
                <span>Connection not working</span>
              </button>
            </Tooltip>
            <button
              v-if="!integration_connected"
              :disabled="loading"
              @click="connectIntegration"
              class="sample font-manrope py-2 w-36 bg-primary font-semibold hover:bg-primary-dark rounded cursor-pointer text-white  disabled:opacity-50"
            >
              Connect
            </button>
          </div>
          <div v-else>
            <button
              class="px-8 py-2 font-manrope bg-primary hover:bg-primary-dark font-semibold rounded cursor-pointer mr-7 text-white  disabled:opacity-50"
              @click="syncIntegration"
              :disabled="loading"
            >
              Sync Assessment
            </button>
          </div>
        </template>
      </div>
      <div v-if="integration_connected && type === 'connect'" class="flex flex-col">
        <div class="flex items-center justify-end mb-2">
          <span v-if="account_integration && account_integration.email" class="text-xs text-gray-500 mr-4">
            {{ account_integration.email }}
          </span>
          <button
            class="py-2 w-36 bg-red-400 rounded cursor-pointer font-semibold text-white  disabled:opacity-50"
            @click="disconnectClass()"
          >
            Disconnect
          </button>
        </div>
        <div class="flex items-center justify-end">
          <span class="text-xs text-gray-500 mr-4">
            {{ integration_course_name }}
          </span>
          <button
            class="py-2 w-36 bg-primary hover:bg-primary-dark font-semibold rounded cursor-pointer text-white disabled:opacity-50"
            @click="updateRoster()"
            :disabled="loading"
          >
            Update Roster
          </button>
        </div>
      </div>
    </div>
    <integrations-premium-feature-modal
      v-if="show_integrations_premium_feature_modal"
      @close="show_integrations_premium_feature_modal = false"
    />
    <integrations-upgrade-modal
      v-if="show_integrations_upgrade_modal"
      @close="show_integrations_upgrade_modal = false"
      :integration_name="integration.name"
      :integration_id="integration.integration_id"
    />
    <google-classroom-modal
      v-if="google_classroom_modal"
      :courses="courses"
      @close="google_classroom_modal = false"
    />
    <disconnect-google-classroom-modal
      v-if="show_disconnect_classroom_modal"
      @close="show_disconnect_classroom_modal = false"
    />
    <disconnect-integration-modal
      v-if="show_disconnect_integration_modal"
      :integration="integration"
      @close="show_disconnect_integration_modal = false"
    />
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import googleClassroomModal from 'components/modals/googleClassroomModal';
  import integrationsPremiumFeatureModal from 'components/modals/integrationsPremiumFeatureModal';
  import integrationsUpgradeModal from 'components/modals/integrationsUpgradeModal';
  import disconnectGoogleClassroomModal from 'components/modals/disconnectGoogleClassroomModal';
  import disconnectIntegrationModal from 'components/modals/disconnectIntegrationModal';

  import { EventBus } from 'utils/event-bus';
  import googleClassroom from 'utils/googleClassroom';
  import urlConfigs from 'services/apiConfigs';

  import googleClassroomService from 'services/googleClassroom/googleClassroomServices';
  import Tooltip from '../../../components/Tooltip.vue';

  export default {
    components: {
      Tooltip,
      googleClassroomModal,
      integrationsPremiumFeatureModal,
      integrationsUpgradeModal,
      disconnectGoogleClassroomModal,
      disconnectIntegrationModal
    },
    data() {
      return {
        loading: false,
        show_integrations_premium_feature_modal: false,
        show_integrations_upgrade_modal: false,
        show_disconnect_classroom_modal:false,
        google_classroom_modal:false,
        show_disconnect_integration_modal: false,
      };
    },
    props:{
      integration: {
        type: Object,
        default() {
          return {};
        },
      },
      title: {
        type: String,
        default: '',
      },
      code: {
        type: String,
        default: '',
      },
      icon:{
        type: String,
        default: '',
      },
      type:{
        type: String,
        default: '',
      },
      memberships:{
        type: Object,
        default() {
          return {};
        },
      }
    },
    computed: {
      ...mapGetters([
        'getCourseDetail',
        'getProfile'
      ]),
      account_connected(){
        if (this.code === 'google-classroom'){
          if (this.getProfile.google_integration) {
            return this.getProfile.google_integration.connected;
          }
          return false;
        }
        else {
          if (this.getProfile.edlink_integrations && this.getProfile.edlink_integrations.length){
            return this.getProfile.edlink_integrations.find(int => int.id === this.integration.integration_id);
          }
          return false;
        }
      },
      has_school_membership(){
        if (this.memberships && this.memberships.school_membership){
          return !this.memberships.school_membership.is_cancelled;
        }
        return false;
      },
      integration_connected() {
        if(this.code === 'google-classroom'){
          if(
            this.getCourseDetail.google_classroom_integration
          ) {
            return this.getCourseDetail.google_classroom_integration.course_id;
          }
          return false;
        } else if(this.integration.connected) {
          if(this.getCourseDetail && this.getCourseDetail.edlink_integrations) {
            const integration= this.getCourseDetail.edlink_integrations.find(
                (integration) => integration.provider_name.toLowerCase() === this.integration.name.toLowerCase());
            return !!integration;
          }
          return false;
        }
        return false;
      },
      account_integration(){
        if (this.code === 'google-classroom'){
          if (this.getProfile.google_integration) {
            return this.getProfile.google_integration;
          }
        }
        else {
          if (this.getProfile.edlink_integrations && this.getProfile.edlink_integrations.length){
            return this.getProfile.edlink_integrations.find(int => int.id === this.integration.integration_id);
          }
        }
        return null;
      },
      integration_course_name(){
        if(this.code === 'google-classroom'){
          return this.getCourseDetail.google_classroom_integration.course_name;
        }else if (this.integration.connected){
          if(this.getCourseDetail && this.getCourseDetail.edlink_integrations) {
            const integration= this.getCourseDetail.edlink_integrations.find(
              (integration) => integration.provider_name.toLowerCase() === this.integration.name.toLowerCase());
            return integration ? integration.course_name : null;
          }
          return;
        }
        return;
      },
    },
    methods:{
      selectIntegration(){
        if (this.type === 'sync'){
          this.syncIntegration();
        }
        else if (this.type === 'connect'){
          this.connectIntegration();
        }
      },
      syncIntegration(){
        if (this.code  === 'google-classroom'){
          EventBus.$emit('selectedIntegrationSync', true);
          return;
        }
        if(!this.getProfile.is_paid || (this.getProfile.is_paid && !this.has_school_membership)){
          this.show_integrations_premium_feature_modal = true;
        } else {
          EventBus.$emit('selectedIntegrationSyncEdLink', true, this.code);
        }
      },
      connectIntegration(){
        if(this.code  === 'google-classroom'){
          this.show_integrations_premium_feature_modal=false;
          this.show_integrations_upgrade_modal = false;
          this.connectOrUpdateGoogleClassroom();
        } else {
          if(!this.getProfile.is_paid || (this.getProfile.is_paid && !this.has_school_membership)){
            this.show_integrations_premium_feature_modal = true;
          }
          else {
            if(this.integration.school_connected){
              this.show_integrations_upgrade_modal=false;
              this.connectToIntegration();
            } else {
              this.show_integrations_upgrade_modal=true;
            }
          }
        }
      },
      updateRoster(){
        if(this.code  === 'google-classroom'){
          this.connectOrUpdateGoogleClassroom();
        } else {
          if (this.account_connected){
            this.$emit('updateRoster', this.integration);
          }
          else{
            EventBus.$emit(
              'connectIntegrationAccount',
              this.integration
            );
          }
        }
      },
      showClassroomCourses(){
          this.loading = true;
          googleClassroomService.getGoogleClassroomCourses(this.getCourseDetail.id).then(({data}) => {
            this.courses = data.courses;
            this.google_classroom_modal = true;
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            this.loading = false;
          }) ;
      },
      async connectOrUpdateGoogleClassroom() {
        if (!this.getProfile.google_integration.connected){
          const {code,email} = await googleClassroom.getCode();
          const redirect_uri = `${urlConfigs.uiURL}`;
          //just for connect
          const data = await this.$store.dispatch('getClassroomToken', { code,redirect_uri, course_id: this.getCourseDetail.id,email });
          if (data){
            this.showClassroomCourses();
          }
        }
        else {
          this.showClassroomCourses();
        }
      },
      connectToIntegration(){
        if (this.getProfile.edlink_integrations){
          const edlink_integration = this.getProfile.edlink_integrations.find(x => x.id === this.integration.integration_id);
          if (edlink_integration){
            EventBus.$emit('show-integration-courses',edlink_integration.id);
            return;
          }
        }
        const course_id = this.$route.params.courseID;
        sessionStorage.setItem('course_id', course_id);
        const integration_id = this.integration.integration_id;
        const redirect_uri =`${urlConfigs.uiURL}/dashboard`;
        this.$store.dispatch('getSsoCourseMetadata', { course_id, redirect_uri,integration_id }).then((res) => {
          if (res.sso_login_url) {
            window.open(res.sso_login_url, '_self');
          }
        });
      },
      disconnectClass(){
        if(this.code === 'google-classroom'){
          this.show_disconnect_classroom_modal=true;
        } else {
          if (this.account_connected){
            this.show_disconnect_integration_modal=true;
          }
          else {
            EventBus.$emit(
              'connectIntegrationAccount',
              this.integration
            );
          }
        }
      },
    },
  };
</script>
<style scoped lang="stylus">
  .integrations-container
    margin: 10px 0 10px 0
    padding: 1rem
    border-bottom: 1px solid rgba(0,0,0,.2)
  .classroom-title
    font-size: 18px
    line-height: 22px
    color: #273248
    font-weight: 600
  .integration-icon
    width: 40px
    height: 40px
  .name-of-class
    font-size: 24px
    line-height: 29px
    color: #273248
    font-weight: 600
</style>



// WEBPACK FOOTER //
// integrationCard.vue?abc3da92